<template>
  <v-container
    fluid
    :class="`py-0 ma-0 ${$vuetify.breakpoint.mobile ? 'px-4' : 'px-8'}`"
  >
    <v-toolbar
      :class="`mx-0 mt-5 mb-5 pa-0 sign-toolbar ${
        $vuetify.breakpoint.mobile ? 'd-flex flex-column' : ''
      }`"
      flat
      dense
      style="background-color: transparent"
    >
      <v-toolbar-title
        class="text-h5 text-wrap font-weight-medium mx-0 px-0 mr-2"
        id="v-step-0"
      >
        {{ $t("migrationHistory.migrationHistoryTitle") }}
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        color="primary"
        elevation="0"
        class="ml-4 text-none text-body-1 font-weight-medium"
        dark
        large
        outlined
        :fab="$vuetify.breakpoint.xs"
        @click="syncMigrationsHistory"
      >
        <v-icon :left="$vuetify.breakpoint.smAndUp">ph-arrows-clockwise</v-icon>
        <span v-if="$vuetify.breakpoint.smAndUp">{{
          $t("migrationHistory.syncLabel")
        }}</span>
      </v-btn>

      <v-tooltip bottom :disabled="!hasTaskRunning ?? true">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <v-btn
              color="accent"
              elevation="0"
              class="ml-4 text-none text-body-1 font-weight-medium"
              large
              :fab="$vuetify.breakpoint.xs"
              @click="openCreateNewMigration"
              :disabled="hasTaskRunning ?? true"
            >
              <v-icon :left="$vuetify.breakpoint.smAndUp">ph-plus</v-icon>
              <span v-if="$vuetify.breakpoint.smAndUp">{{
                $t("migrationHistory.createMigrationProjectLabel")
              }}</span>
            </v-btn>
          </span>
        </template>
        <span>
          {{ $t("migrationHistory.migrationInProgress") }}
        </span>
      </v-tooltip>
    </v-toolbar>
    <MigrationAlertUpgradePlan />
    <MigrationsHistoryTable />
  </v-container>
</template>

<script>
import MigrationAlertUpgradePlan from "@/components/migration/MigrationAlertUpgradePlan.vue";
import MigrationsHistoryTable from "@/components/migration/MigrationsHistoryTable.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "MigrationsHistory",

  components: {
    MigrationsHistoryTable,
    MigrationAlertUpgradePlan,
  },
  data() {
    return {
      hasTaskRunning: true,
    };
  },
  computed: {
    ...mapGetters(["company", "migrationsHistory", "hasIntegracaoPontoMais"]),
    migrationsAndCompany() {
      return {
        migrationsHistory: this.migrationsHistory,
        current_plan: this.company?.current_plan,
      };
    },
  },
  methods: {
    ...mapActions(["syncMigrationsHistory", "checkHasTaskRunningByCompany"]),

    openCreateNewMigration() {
      this.$router.push({ name: "CreateMigration" });
    },
  },
  watch: {
    migrationsAndCompany: {
      immediate: true,
      async handler() {
        if (this.hasIntegracaoPontoMais) {
          this.hasTaskRunning = false;
          return;
        }
        this.hasTaskRunning = await this.checkHasTaskRunningByCompany();
      },
    },
  },
};
</script>
